import { createContext, useContext } from 'react';

import type { ICopyProps } from '../components/reusable/hooks';

export const CopyPropsContext = createContext<ICopyProps | null>(null);

export const useCopyPropsContext = (): ICopyProps => {
	const copyPropsContext = useContext(CopyPropsContext);

	if (!copyPropsContext) {
		throw new Error('useGlobalContext must be used within a GlobalProvider');
		// } catch (error) {}
	}

	return {
		...copyPropsContext,
	};
};
